var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0817 5.26313C8.56852 6.6193 9.27115 10.2357 9.27115 12.7221C9.27115 14.0782 10.0484 16.5375 7.16332 16.7906C-0.565636 17.4687 -0.565688 21.5372 0.839578 23.5714C2.24484 25.6057 5.21496 26.3054 9.97389 24.9276C17.0001 22.8933 21.9187 16.196 21.9187 13.4002C21.967 10.7188 19.0637 8.89326 17.606 8.31565C15.9392 4.79052 13.2286 4.81183 12.0817 5.26313Z",
    fill: "#48C0B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6898 4.58503C11.6838 3.90692 14.1439 -1.75761 17.203 1.1946C20.0135 3.90694 15.6958 5.26314 13.6898 4.58503Z",
    fill: "#48C0B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5014 4.58503C19.3771 2.95761 16.7984 4.38986 16.6611 5.97227C17.1336 6.12849 18.0785 6.72215 18.0785 7.84697C19.6058 8.34226 22.5801 10.0747 22.2593 13.0423C22.6984 12.5144 23.3273 11.4442 23.0211 9.71048C22.8372 8.66892 22.5735 8.12611 22.2592 7.82931C21.7511 7.34946 21.2158 6.65924 21.0979 5.97038C21.0294 5.56985 20.8575 5.1006 20.5014 4.58503Z",
    fill: "#48C0B9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2697 27.4841L17.203 24.2507L20.5014 24.7193V21.9073H23.2755L21.9187 20.0326L24.2205 18.6265L21.8582 17.2205L26.9338 17.6078C27.3026 17.636 27.4389 18.1068 27.1421 18.3276L24.2205 20.5013L26.377 23.8686C26.5874 24.1971 26.2513 24.6016 25.8899 24.455L21.9187 22.8446V27.171C21.9187 27.5059 21.5318 27.6925 21.2697 27.4841Z",
    fill: "#48C0B9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKick);
export default __webpack_public_path__ + "static/media/kick.29877cebcb947477556f72ed94b7e754.svg";
export { ForwardRef as ReactComponent };